//tabs
import DashboardIcon from './Tabs/icon (1).png';
import DoctorIcon from './Tabs/icon (2).png';
import CustomerIcon from './Tabs/icon (3).png';
import ApprovalsIcon from './Tabs/icon (4).png';
import ServicesIcon from './Tabs/icon (5).png';
import RenewalsIcon from './Tabs/icon (6).png';
import CmsIcon from './Tabs/icon (7).png';
import RolesPermissionIcon from './Tabs/icon (7).png';
import NotificationIcon from './Tabs/icon (7).png';
import MenuIcon from './icons/menuicon.png';





//login

import loginImage from './images/login.png';
import logoImage from './logos/sinn_logo.png';
import sinnlabel from './logos/SinnLabel.png';

import Doctoricon from './icons/DocotIcon.png';
import Usericon from './icons/UsersIcon.png';
import Inactiveicon from './icons/InactiveIcon.png';
import Earningsicon from './icons/EarningsIcon.png';


import Periodontics from './icons/periodontics.png';
import Orthodontics from './icons/orthodontics.png';
import Preventivecare from './icons/preventivecare.png';




import cms from './images/cms.png';














































export const TabsIcons = {
    DoctorIcon,
    ApprovalsIcon,
    CustomerIcon,
    DashboardIcon,
    NotificationIcon,
    ServicesIcon,
    RenewalsIcon,
    CmsIcon,
    RolesPermissionIcon,
    
};


export {loginImage, logoImage , sinnlabel, MenuIcon };
export {cms}

export const DashboardIcons ={
    Doctoricon,
    Usericon,
    Inactiveicon,
    Earningsicon
};

export const ServiceIcons = {
    Periodontics,
    Preventivecare,
    Orthodontics
};